import React, { Component } from 'react'
import ReactDOM from 'react-dom'

export default class Item extends Component {

  componentDidMount() {
    this.ensureVisible();
  }

  componentDidUpdate() {
    this.ensureVisible();
  }

  ensureVisible() {
    if (this.props.curr) {
      this.props.scrollIntoView(ReactDOM.findDOMNode(this));
    }
  }

  render() {
    const {item, onClick, curr} = this.props
    return (
      <div className={'item' + (curr ? ' active' : '')} onClick={onClick}>
        <div className="info">
      <span className="title">
        {item.title}
      </span>
          <br />
          {item.subtitle && (
            <span className="title">
          {item.subtitle}
        </span>
          )}
        </div>
        <div className="thumbnail">
          <img className="img" src={item.poster} alt=""/>
        </div>

      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/Item.js